<template>
  <div id="app">
    <router-view />
    <CookieBanner />
  </div>
</template>

<script>
import CookieBanner from './components/CookieBanner.vue';

export default {
  components: { CookieBanner },
};
</script>
